var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled from 'styled-components';
export var Path15 = styled.path(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fill: ", ";\n"], ["\n  fill: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.chart.primary.child2;
});
export var Path30 = styled.path(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  fill: ", ";\n"], ["\n  fill: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.tokens.chart.primary.child1;
});
var templateObject_1, templateObject_2;